import { defineStore } from 'pinia';
import { useSettingsStore } from '@/stores/settings';

export const useAnalyticsStore = defineStore('analytics', {
  state: () => ({
    analyticsInitialized: false,
  }),
  getters: {
    isAnalyticsInitialized: (state) => state.analyticsInitialized,
  },
  actions: {
    setAnalyticsInitialized(value) {
      this.analyticsInitialized = value;
    },
    initializeAnalytics() {
      const settingsStore = useSettingsStore();
      const apiUrl = settingsStore.settings.apiUrl;

      if (window.gtag && !this.analyticsInitialized) {
        window.gtag('config', 'G-QTYQ7961QF', {
          custom_map: {
            dimension1: 'parent_url',
          },
          parent_url: apiUrl,
        });
        this.analyticsInitialized = true;
      }
    },
    trackEvent({ eventName, params = {}, userEmail = null }) {
      if (window.gtag) {
        const settingsStore = useSettingsStore();
        const eventParams = {
          ...params,
          parent_url: settingsStore.settings.apiUrl,
        };

        if (userEmail) {
          eventParams.user_email = userEmail;
        }

        window.gtag('event', eventName, eventParams);
      }
    },
    trackPage({ pageUrl, userEmail = null }) {
      if (window.gtag) {
        const settingsStore = useSettingsStore();
        const configParams = {
          page_path: pageUrl,
          parent_url: settingsStore.settings.apiUrl,
        };

        if (userEmail) {
          configParams.user_email = userEmail;
        }

        window.gtag('config', 'G-QTYQ7961QF', configParams);
      }
    },
  },
});
